import type { ErrorDetailsData } from '../../types';
import { CodeBlock } from '../code-block';

type P = {
  details: ErrorDetailsData;
};

export const useGetCollapseItems = ({ details }: P) => {
  const { additionalData = [] } = details;

  return additionalData.map(({ data, title }) => ({ children: <CodeBlock value={data} />, key: title, label: title }));
};
